(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    function setupHakdAccordions() {
  const duration = 240;
  const overlapDelay = 140;
  const easing = 'cubic-bezier(.4, 0, .2, 1)';

  const wait = milliseconds =>
    new Promise(resolve => setTimeout(resolve, milliseconds));

  const finish = animation =>
    animation.finished.catch(() => {});

  function stabiliseContent(content) {
    let inner = content.querySelector(':scope > .hakd-accordion-inner');

    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'hakd-accordion-inner';

      while (content.firstChild) {
        inner.appendChild(content.firstChild);
      }

      content.appendChild(inner);
    }
  }

  async function closeRow(row) {
    const content = row.querySelector('.details-content');

    if (!content) {
      row.open = false;
      return;
    }

    const height = content.getBoundingClientRect().height;

    const animation = content.animate(
      [
        { blockSize: height + 'px' },
        { blockSize: '0px' }
      ],
      { duration, easing, fill: 'forwards' }
    );

    await finish(animation);
    row.open = false;
    animation.cancel();
  }

  async function openRow(row) {
    const content = row.querySelector('.details-content');

    if (!content) {
      row.open = true;
      return;
    }

    row.open = true;
    const height = content.scrollHeight;

    const animation = content.animate(
      [
        { blockSize: '0px' },
        { blockSize: height + 'px' }
      ],
      { duration, easing, fill: 'forwards' }
    );

    await finish(animation);
    animation.cancel();
  }

  document
    .querySelectorAll('.product-information .accordion')
    .forEach(accordion => {
      if (accordion.dataset.hakdSmooth) return;

      accordion.dataset.hakdSmooth = 'true';
      accordion.classList.add('hakd-smooth');

      const rows = [...accordion.querySelectorAll('details')];

      rows.forEach(row => {
        row.removeAttribute('name');

        const content = row.querySelector('.details-content');
        if (content) stabiliseContent(content);
      });

      accordion.addEventListener('click', async event => {
        const summary = event.target.closest('summary');
        if (!summary || !accordion.contains(summary)) return;

        event.preventDefault();

        if (accordion.dataset.animating === 'true') return;
        accordion.dataset.animating = 'true';

        const target = summary.closest('details');

        if (target.open) {
          await closeRow(target);
        } else {
          const current = rows.find(
            row => row.open && row !== target
          );

          if (current) {
            const closing = closeRow(current);

            await wait(overlapDelay);

            const opening = openRow(target);
            await Promise.all([closing, opening]);
          } else {
            await openRow(target);
          }
        }

        accordion.dataset.animating = 'false';
      }, true);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    setupHakdAccordions
  );
} else {
  setupHakdAccordions();
}
  } catch(e) { console.error(e); }
})();

})();
